import { Typography } from "@mui/material";

const VpnLoginHint = () => (
  <Typography
    component="p"
    sx={{
      mt: 0.75,
      mb: 0,
      fontSize: { xs: "0.72rem", sm: "0.78rem" },
      lineHeight: 1.6,
      color: "text.secondary",
    }}
  >
    برای ورود به سامانه، فیلترشکن (VPN) را خاموش کنید.
  </Typography>
);

export default VpnLoginHint;
